export default __webpack_public_path__ + "static/media/EM0750.34I-23429_-15263_0.0cef62a8.jpg";